import { User, UserAction } from '@core/models';
import { createAction, props } from '@ngrx/store';
import { UsersState } from '../reducers/users.reducer';

export const LOAD_ORG_USERS = '[Users] Load Organization Users';
export const LOAD_ORG_USERS_SUCCESS = '[Users] Load Organization Users Success';
export const RESET_USER = '[User] Reset Token and User';
export const LOAD_USER = '[Users] Load User';
export const LOAD_USER_SUCCESS = '[Users] Load User Success';
export const SET_CONNECTION = '[Users] Set Connection Properties';
export const LOAD_USERS = '[Users] Load Users';
export const LOAD_USERS_SUCCESS = '[Users] Load Users Success';

export const DELETE_USER = '[User] Delete User';
export const DELETE_USER_SUCCESS = '[User] Delete User Success';

export const CREATE_OR_UPDATE_USER = '[Users] Create or Update';
export const CREATE_OR_UPDATE_USER_SUCCESS = '[Users] Create or Update User Success';
export const SET_SORT_ORDER = '[Users] Set Sort Order';
export const ACCEPT_EULA = '[User] Accept Eula';
export const ACCEPT_EULA_SUCCESS = '[User] Accept Eula Success';

export const UPDATE_USER_SEARCH_OPTION = '[User] Search Options Update';
export const UPDATE_USER_SEARCH_OPTION_SUCCESS = '[User] Search Options Update Success';

export const AUTHORIZE_USER = '[Users] Authorize User';
export const AUTHORIZE_USER_SUCCESS = '[Users] Authorize Users Success';

export const authorizeUser = createAction(AUTHORIZE_USER);
export const authorizeUserSuccess = createAction(AUTHORIZE_USER_SUCCESS);

export const loadUser = createAction(LOAD_USER);
export const loadUserSuccess = createAction(LOAD_USER_SUCCESS, props<{ user: User }>());

export const setConnection = createAction(SET_CONNECTION, props<{ usersState: UsersState }>());

export const loadUsers = createAction(LOAD_USERS);
export const loadUsersSuccess = createAction(LOAD_USERS_SUCCESS, props<{ users: User[] }>());

export const loadOrgUsers = createAction(LOAD_ORG_USERS, props<{ orgId: number }>());
export const loadOrgUsersSuccess = createAction(LOAD_ORG_USERS_SUCCESS, props<{ users: User[] }>());

export const deleteUser = createAction(DELETE_USER, props<{ user: User }>());
export const deleteUserSuccess = createAction(DELETE_USER_SUCCESS);

export const createOrUpdateUser = createAction(CREATE_OR_UPDATE_USER, props<{ userAction: UserAction }>());
export const createOrUpdateUserSuccess = createAction(CREATE_OR_UPDATE_USER_SUCCESS, props<{ userAction: UserAction }>());
export const createOrUpdateUserFailure = createAction('[Users] Create or Update User Failure', props<{ userAction: UserAction, error: string }>());

export const setSortOrder = createAction(SET_SORT_ORDER, props<{ payload: string }>());

export const acceptEula = createAction(ACCEPT_EULA, props<{ userAction: UserAction }>());
export const acceptEulaSuccess = createAction(ACCEPT_EULA_SUCCESS, props<{ userAction: UserAction }>());

export const updateUserPreference = createAction('[User] Preferences Update', props<{ user: User }>());
export const updateUserPreferenceSuccess = createAction('[User] Preferences Update Success');
export const updateUserPreferenceFailure = createAction('[User] Preferences Update Failure', props<{ error: string }>());

export const updateUserSearchOption = createAction(UPDATE_USER_SEARCH_OPTION, props<{ userAction: UserAction }>());
export const updateUserSearchOptionSuccess = createAction(UPDATE_USER_SEARCH_OPTION_SUCCESS, props<{ user: User }>());
export const updateUserSearchOptionFailure = createAction('[User] Search Options Update Failure', props<{ userAction: UserAction, error: string }>());



